import {
  FrontSelfContractListVO,
  FrontSelfContractAttachmentStatusVO,
} from '@/api/selfAgreementApi/response'
import { fileFile } from '@/modules/uploadfiles/hooks'

interface PaginationOption {
  total: number
  current: number
  pagesize: number
}

export interface State {
  dataSource: FrontSelfContractListVO[]
  isTableLoading: boolean
  paginationOption: PaginationOption
  searchParam: Record<string, unknown>
  selectedRows: FrontSelfContractListVO[]
  selectedRowKeys: string[]
  // 批量下载 loading（防重复提交）
  downloadLoading: boolean
  // 协议附件弹窗
  showList: boolean
  fileList: fileFile[]
  fileStatus?: FrontSelfContractAttachmentStatusVO
  reason: string
  agreementId: string
}

type ActionType =
  | 'setPaginationOptionAction'
  | 'setDataSourceAction'
  | 'setIsTableLoading'
  | 'setSearchParamAction'
  | 'setSelectedRowsAction'
  | 'setSelectedRowKeysAction'
  | 'setDownloadLoadingAction'
  | 'setShowListAction'
  | 'setFileListAction'
  | 'setFileDetailAction'
  | 'reloadStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isTableLoading: false,
  paginationOption: {
    total: 0,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  selectedRowKeys: [],
  downloadLoading: false,
  showList: false,
  fileList: [],
  fileStatus: undefined,
  reason: '',
  agreementId: '',
}

export const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setSelectedRowKeysAction':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setDownloadLoadingAction':
      newstate.downloadLoading = action.payload
      return newstate
    case 'setShowListAction':
      newstate.showList = action.payload.showList
      if (action.payload.agreementId !== undefined) {
        newstate.agreementId = action.payload.agreementId
      }
      return newstate
    case 'setFileListAction':
      newstate.fileList = action.payload
      return newstate
    case 'setFileDetailAction':
      newstate.fileStatus = action.payload.fileStatus
      newstate.fileList = action.payload.fileList
      newstate.reason = action.payload.reason
      return newstate
    case 'reloadStateAction':
      return action.payload
    default:
      throw new Error('no match actions')
  }
}

export const setSearchParamAction = (
  val: Record<string, unknown>,
): Action => ({
  type: 'setSearchParamAction',
  payload: val,
})

export const setPaginationOptionAction = (val: PaginationOption): Action => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

export const setDataSourceAction = (
  val: FrontSelfContractListVO[],
): Action => ({
  type: 'setDataSourceAction',
  payload: val,
})

export const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})

export const setSelectedRowsAction = (
  val: FrontSelfContractListVO[],
): Action => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

export const setSelectedRowKeysAction = (val: string[]): Action => ({
  type: 'setSelectedRowKeysAction',
  payload: val,
})

export const setDownloadLoadingAction = (val: boolean): Action => ({
  type: 'setDownloadLoadingAction',
  payload: val,
})

// 打开/关闭协议附件弹窗，可携带 agreementId
export const setShowListAction = (val: {
  showList: boolean
  agreementId?: string
}): Action => ({
  type: 'setShowListAction',
  payload: val,
})

export const setFileListAction = (val: fileFile[]): Action => ({
  type: 'setFileListAction',
  payload: val,
})

// 设置附件详情（审核状态、附件、驳回原因）
export const setFileDetailAction = (val: {
  fileStatus?: FrontSelfContractAttachmentStatusVO
  fileList: fileFile[]
  reason: string
}): Action => ({
  type: 'setFileDetailAction',
  payload: val,
})

export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})
import {
  FrontSelfContractListVO,
  FrontSelfContractAttachmentStatusVO,
} from '@/api/selfAgreementApi/response'
import { fileFile } from '@/modules/uploadfiles/hooks'

interface PaginationOption {
  total: number
  current: number
  pagesize: number
}

export interface State {
  dataSource: FrontSelfContractListVO[]
  isTableLoading: boolean
  paginationOption: PaginationOption
  searchParam: Record<string, unknown>
  selectedRows: FrontSelfContractListVO[]
  selectedRowKeys: string[]
  // 批量下载 loading（防重复提交）
  downloadLoading: boolean
  // 协议附件弹窗
  showList: boolean
  fileList: fileFile[]
  fileStatus?: FrontSelfContractAttachmentStatusVO
  reason: string
  agreementId: string
}

type ActionType =
  | 'setPaginationOptionAction'
  | 'setDataSourceAction'
  | 'setIsTableLoading'
  | 'setSearchParamAction'
  | 'setSelectedRowsAction'
  | 'setSelectedRowKeysAction'
  | 'setDownloadLoadingAction'
  | 'setShowListAction'
  | 'setFileListAction'
  | 'setFileDetailAction'
  | 'reloadStateAction'

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  dataSource: [],
  isTableLoading: false,
  paginationOption: {
    total: 0,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  selectedRows: [],
  selectedRowKeys: [],
  downloadLoading: false,
  showList: false,
  fileList: [],
  fileStatus: undefined,
  reason: '',
  agreementId: '',
}

export const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParamAction':
      newstate.searchParam = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setSelectedRowKeysAction':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setDownloadLoadingAction':
      newstate.downloadLoading = action.payload
      return newstate
    case 'setShowListAction':
      newstate.showList = action.payload.showList
      if (action.payload.agreementId !== undefined) {
        newstate.agreementId = action.payload.agreementId
      }
      return newstate
    case 'setFileListAction':
      newstate.fileList = action.payload
      return newstate
    case 'setFileDetailAction':
      newstate.fileStatus = action.payload.fileStatus
      newstate.fileList = action.payload.fileList
      newstate.reason = action.payload.reason
      return newstate
    case 'reloadStateAction':
      return action.payload
    default:
      throw new Error('no match actions')
  }
}

export const setSearchParamAction = (
  val: Record<string, unknown>,
): Action => ({
  type: 'setSearchParamAction',
  payload: val,
})

export const setPaginationOptionAction = (val: PaginationOption): Action => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

export const setDataSourceAction = (
  val: FrontSelfContractListVO[],
): Action => ({
  type: 'setDataSourceAction',
  payload: val,
})

export const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})

export const setSelectedRowsAction = (
  val: FrontSelfContractListVO[],
): Action => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

export const setSelectedRowKeysAction = (val: string[]): Action => ({
  type: 'setSelectedRowKeysAction',
  payload: val,
})

export const setDownloadLoadingAction = (val: boolean): Action => ({
  type: 'setDownloadLoadingAction',
  payload: val,
})

// 打开/关闭协议附件弹窗，可携带 agreementId
export const setShowListAction = (val: {
  showList: boolean
  agreementId?: string
}): Action => ({
  type: 'setShowListAction',
  payload: val,
})

export const setFileListAction = (val: fileFile[]): Action => ({
  type: 'setFileListAction',
  payload: val,
})

// 设置附件详情（审核状态、附件、驳回原因）
export const setFileDetailAction = (val: {
  fileStatus?: FrontSelfContractAttachmentStatusVO
  fileList: fileFile[]
  reason: string
}): Action => ({
  type: 'setFileDetailAction',
  payload: val,
})

export const reloadStateAction = (val: State): Action => ({
  type: 'reloadStateAction',
  payload: val,
})
